/**
 * Statistics Grid Component
 * Main container for dashboard statistics cards
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  InventoryStatCard, 
  ReservationStatCard, 
  CustomerStatCard, 
  RevenueStatCard 
} from './StatCard';

const StatsGrid = ({ stats, loading, error, onRefresh }) => {
  const navigate = useNavigate();

  const handleStatClick = (route) => {
    if (route) {
      navigate(route);
    }
  };

  if (error) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        <div className="col-span-full bg-red-50 border border-red-200 rounded-lg p-4">
          <div className="flex items-center justify-between">
            <div>
              <h3 className="text-sm font-medium text-red-800">
                Failed to load statistics
              </h3>
              <p className="text-sm text-red-700 mt-1">{error}</p>
            </div>
            <button
              onClick={onRefresh}
              className="px-3 py-1 text-sm text-red-800 border border-red-300 rounded hover:bg-red-100"
            >
              Retry
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
      <InventoryStatCard 
        stats={stats?.inventory} 
        loading={loading}
        onClick={() => handleStatClick('/inventory')}
      />
      
      <ReservationStatCard 
        stats={stats?.reservations} 
        loading={loading}
        onClick={() => handleStatClick('/reservations')}
      />
      
      <CustomerStatCard 
        stats={stats?.customers} 
        loading={loading}
        onClick={() => handleStatClick('/customers')}
      />
      
      <RevenueStatCard 
        stats={stats?.payments} 
        loading={loading}
        onClick={() => handleStatClick('/reports')}
      />
    </div>
  );
};

export default StatsGrid;